import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { appConfig } from 'brand-config';
import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import { awsDateToDateFormatter, currencyFormatter } from 'core/helpers/formatters';
import icon from 'core/assets/svg/alert-white-bold.svg';
import useStyles from '../payment.styles';

/**
 * #37684: a note that the amount owed includes what the previous billing system (CFMGo) billed before the cutover and
 * is still unpaid. Informational only: that balance is an ordinary past-due installment, in the amount owed and the
 * next payment, paid by any payment and drafted like any other.
 */
const LegacyBalanceNotice = ({ legacyBalanceDue }) => {
  const classes = useStyles();
  const amount = Number(legacyBalanceDue?.amount) || 0;
  if (amount <= 0) {
    return null;
  }
  const systemName = appConfig?.importedLegacySystemName ?? 'previous billing system';
  const dueDate = legacyBalanceDue?.dueDate ? awsDateToDateFormatter(legacyBalanceDue.dueDate) : null;
  return (
    <Grid item>
      <Card className={classes.smallContainer} data-testid="legacy-balance-notice">
        <Grid className={classes.centeredContentContainer}>
          <img src={icon} className={classes.smallIcon} alt="" />
          <Label type="notificationText">
            {`The amount owed includes ${currencyFormatter(amount)} billed in ${systemName} before the move to this system${dueDate ? `, due ${dueDate}` : ''}.`}
          </Label>
        </Grid>
      </Card>
    </Grid>
  );
};

LegacyBalanceNotice.propTypes = {
  legacyBalanceDue: PropTypes.shape({ amount: PropTypes.number, dueDate: PropTypes.string })
};

LegacyBalanceNotice.defaultProps = {
  legacyBalanceDue: null
};

export default LegacyBalanceNotice;
